<template>
  <slot></slot>
</template>